<template>
  <div>
    <Select
      prefix="ios-search"
      @on-change="change"
      clearable
      @on-query-change="queryChange"
      style="width: 260px"
      :placeholder="$t('newOrder.placeCommon')"
      :not-found-text="$t('noDate')"
      filterable
    >
      <Option v-for="item in searchColor" :value="item.id" :key="item.id">{{
        item.name
      }}</Option>
    </Select>
  </div>
</template>
<script>
export default {
    props:{
        config:[Object,Array],
        list:Array
    },
    data(){
        return {
            searchColor:[]
        }
    },
    watch:{
        list:{
            handler(newval,oldval){
                this.searchColor = newval
            },
            immediate:true
        }
    },
    methods:{
        change(e){
            this.$emit('change',e,this.config)
        },
        queryChange(e){
            this.$emit('queryChange',e,this.config)
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/r-search-emb.vue